<script setup lang="ts">
import Prices from '~/components/product/Prices.vue';
import { getImageContext } from '~/helpers/product/productHelper';
import type { IPriceDTO } from '~/interfaces/product/IPriceDTO';
import type { ILabel } from '~/interfaces/crossSell/ICrossSell';
import Eclat from '~/components/eclats/eclat.vue';
import ReviewStars from '~/components/reviews/review-stars.vue';

const props = defineProps<{
  mainImageContext: never
  mainImageImageJpg2x: string
  mainImageImageWebp2x: string
  nameWithoutBrand: string
  withoutRetina: boolean
  hideLabel: boolean
  label?: ILabel
  setAsTitle: boolean
  brandName: string
  globalRateCount: number
  productId: number
  priceDto: IPriceDTO,
  sport: string
  globalRate: number
}>()

const {
  mainImageContext,
  mainImageImageJpg2x,
  mainImageImageWebp2x,
  nameWithoutBrand,
  withoutRetina,
  hideLabel,
  label,
  brandName,
  productId,
  priceDto,
  sport,
  globalRate
} = toRefs(props)

const srcsetJPG = computed(() => {
  if (withoutRetina.value) return mainImageImageJpg2x.value;
  return `${mainImageImageJpg2x.value} 1x, ${mainImageImageJpg2x.value} 2x`;
});

const srcsetWEBP = computed(() => {
  if (withoutRetina.value) return mainImageImageWebp2x.value;
  return `${mainImageImageWebp2x.value} 1x, ${mainImageImageWebp2x.value} 2x`;
});
</script>

<template>
  <div>
    <NuxtLink
:to="localePath({name: 'p-sport-slug', params: {slug: 'ghost-max-brooks-homme-'+productId, sport: sport}})"
              class="cproduct">
      <div :class="`image__container--product image ${getImageContext(mainImageContext)}`">
        <div class="image--product">
          <picture>
            <source type="image/webp" :srcset="srcsetWEBP" >
            <source type="image/jpeg" :srcset="srcsetJPG" >
            <img :src="mainImageImageJpg2x" :alt="nameWithoutBrand" >
          </picture>
        </div>
        <eclat v-if="label && !hideLabel" :label="label" />
      </div>
      <div class="cproduct__inner">
        <div class="cproduct__description">
          <div>
            <h2 v-if="setAsTitle">
              <span class="cproduct__brand-name uppercase-text">{{ brandName }}&#32;</span>
              <span class="cproduct__product-name" :title="nameWithoutBrand"><span>{{ nameWithoutBrand }}</span></span>
            </h2>
            <div v-else>
              <span class="cproduct__brand-name uppercase-text">{{ brandName }}&#32;</span>
              <span class="cproduct__product-name" :title="nameWithoutBrand"><span>{{ nameWithoutBrand }}</span></span>
            </div>
          </div>
        </div>
        <div class="price-text">
          <prices
:price-dto="priceDto"
                  :is-small="true" />
        </div>
        <div v-if="globalRateCount" class="cproduct__rating">
          <div>
            <div class="df aife">
              <review-stars v-if="globalRateCount" :rate="globalRate" />
              <span class="cproduct__review-count">({{ globalRateCount }})</span>
            </div>
          </div>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>
